"use strict";

define('controller/study/list',['require','exports','module','underscore','handlebars','../base','view/page.list','config','model/study','model/user','model/sort','libs/route.helper','libs/format/link','libs/format/bold','libs/format/date','libs/format/empty','libs/format/status','adapter/param','libs/filter_format/expirationDate','libs/filter_format/adminCheckinDate','libs/filter_format/finalizedDate','langs','view/empty.table','templates','uikit/uikit'],function (require, exports, module) {
  'use strict';

  var _ = require('underscore');
  var Handlebars = require('handlebars');
  var RegionController = require('../base');
  var PageList = require('view/page.list');
  var config = require('config');
  var Study = require('model/study');
  var User = require('model/user');
  var Sort = require('model/sort');
  var RouteHelper = require('libs/route.helper');
  var linkFormatter = require('libs/format/link');
  var boldFormatter = require('libs/format/bold');
  var dateFormatter = require('libs/format/date');
  var emptyFormatter = require('libs/format/empty');
  var statusFormatter = require('libs/format/status');
  var ParamAdapter = require('adapter/param');
  var expirationDateFormatter = require('libs/filter_format/expirationDate');
  var adminCheckinDateFormatter = require('libs/filter_format/adminCheckinDate');
  var finalizedDateFormtter = require('libs/filter_format/finalizedDate');
  var langs = require('langs');
  var EmptyTableView = require('view/empty.table');
  var Templates = require('templates');
  var UIKit = require('uikit/uikit');
  var EXPIRATION_VALUES = [{
    description: '30 days'
  }, {
    description: '60 days'
  }, {
    description: '90 days'
  }, {
    description: 'Expired'
  }];
  var ADMIN_CHECKIN_DATE_VALUES = [{
    description: 'Check-in Within 30 days'
  }, {
    description: 'Check-in Within 60 days'
  }, {
    description: 'Check-in Within 90 days'
  }, {
    description: 'Check-in Past Due'
  }];
  var FINALIZED_VALUES = [{
    description: '1 year'
  }, {
    description: '2 years'
  }, {
    description: '3 years'
  }];
  var p = langs.phrase;
  var STUDY_FIELDS = [{
    displayName: p('StudiesPage.VSFields.Label'),
    name: 'label',
    autoComplete: {
      entity: 'study',
      field: 'label'
    },
    sortName: 'label',
    displayOrder: 2
  }, {
    displayName: p('StudiesPage.VSFields.PI'),
    name: 'principalInvestigator',
    autoComplete: {
      entity: 'person',
      field: 'fullName'
    },
    sortName: 'lastName',
    displayOrder: 2
  }, {
    displayName: p('StudiesPage.VSFields.Status'),
    name: 'status',
    autoComplete: {
      entity: 'study',
      field: 'status'
    },
    displayOrder: 2
  }, {
    displayName: p('StudiesPage.VSFields.StudyTitle'),
    name: 'title',
    autoComplete: {
      entity: 'study',
      field: 'title'
    },
    sortName: 'title',
    displayOrder: 2
  }, {
    displayName: p('StudiesPage.VSFields.ExpiringWithin'),
    name: 'expirationDate',
    autoComplete: new Backbone.Collection(EXPIRATION_VALUES),
    displayOrder: 2
  }, {
    displayName: p('StudiesPage.VSFields.AdminCheckInDate'),
    name: 'adminCheckinDate',
    autoComplete: new Backbone.Collection(ADMIN_CHECKIN_DATE_VALUES),
    displayOrder: 2
  }, {
    displayName: p('StudiesPage.VSFields.All'),
    name: 'q',
    displayOrder: 1
  }];
  var ARCHIVED_STUDY_FIELDS = [{
    displayName: 'Archived Within',
    name: 'finalizedDate',
    autoComplete: new Backbone.Collection(FINALIZED_VALUES)
  }];
  var STUDY_COLUMNS = [{
    data: 'label',
    text: p('StudiesPage.Columns.Label'),
    formatter: linkFormatter('study:detail', {
      studyId: 'id'
    }),
    sortable: false,
    nowrap: true
  }, {
    data: 'title',
    text: p('StudiesPage.Columns.StudyTitle'),
    formatter: boldFormatter,
    sortable: false,
    maxWidth: '20em'
  }, {
    data: 'status',
    text: p('StudiesPage.Columns.Status'),
    formatter: statusFormatter(),
    sortable: false
  }, {
    data: 'principalInvestigator',
    text: p('StudiesPage.Columns.PI'),
    formatter: emptyFormatter(new Handlebars.SafeString('<i>Unassigned</i>')),
    sortable: false
  }, {
    data: 'expirationDate',
    text: p('StudiesPage.Columns.ExpDate'),
    formatter: dateFormatter(null, 'N/A'),
    sortable: true,
    collapsing: true,
    type: 'date'
  }, {
    data: 'adminCheckinDate',
    text: p('StudiesPage.Columns.AdminCheckinDate'),
    formatter: dateFormatter(null, 'N/A'),
    sortable: true,
    collapsing: true,
    type: 'date'
  }, {
    data: 'createDate',
    text: p('StudiesPage.Columns.CreateDate'),
    formatter: dateFormatter(),
    sortable: true,
    collapsing: true,
    type: 'date'
  }];
  var ARCHIVED_STUDY_COLUMNS = [{
    data: 'finalizedDate',
    text: 'Archive Date',
    formatter: dateFormatter(null, 'N/A'),
    sortable: true,
    collapsing: true,
    type: 'date'
  }];
  var FILTER_OPTIONS = {
    format: {
      expirationDate: expirationDateFormatter,
      adminCheckinDate: adminCheckinDateFormatter,
      finalizedDate: finalizedDateFormtter
    }
  };
  var DEFAULT_SORT = {
    sort: 'createDate',
    sortDirection: Sort.DESCENDING
  };
  var ToolbarMenuItem = UIKit.Menu.Item.extend({
    events: _.extend(UIKit.Menu.Item.prototype.events, {
      'keydown': 'handleToolbarOnKeydown'
    }),
    handleToolbarOnKeydown: function handleToolbarOnKeydown(ev) {
      switch (ev.keyCode) {
        case 13:
          ev.preventDefault();
          this.handleClick();
          break;
        case 37:
        case 39:
          var toolbarItems = this._parent._views;
          var nextToolbarItem = toolbarItems[0].view === this ? toolbarItems[1].view : toolbarItems[0].view;
          ev.preventDefault();
          nextToolbarItem.$el.focus();
          break;
        default:
          break;
      }
    }
  });
  var StudyListController = RegionController.extend({
    header: p('App.Title'),
    getStudyFields: function getStudyFields() {
      var studyFields = STUDY_FIELDS.slice(0);
      if (this.state.get('type') == 'archive') {
        studyFields = _.without(studyFields, _.findWhere(studyFields, {
          name: 'expirationDate'
        }));
        studyFields = _.without(studyFields, _.findWhere(studyFields, {
          name: 'adminCheckinDate'
        }));
        studyFields = studyFields.concat(ARCHIVED_STUDY_FIELDS);
      }
      return studyFields;
    },
    getStudyColumns: function getStudyColumns() {
      var studyColumns = STUDY_COLUMNS.slice(0);
      if (this.state.get('type') == 'archive') {
        var createDateColumn = _.findWhere(studyColumns, {
          data: 'createDate'
        });
        studyColumns = _.without(studyColumns, _.findWhere(studyColumns, {
          data: 'expirationDate'
        }));
        studyColumns = _.without(studyColumns, _.findWhere(studyColumns, {
          data: 'adminCheckinDate'
        }));
        studyColumns = _.without(studyColumns, createDateColumn);
        studyColumns = studyColumns.concat(ARCHIVED_STUDY_COLUMNS).concat([createDateColumn]);
      }
      return studyColumns;
    },
    onChangeStateType: function onChangeStateType() {
      if (this.state.get('type') == 'archive') {
        this.root.archiveMenuItem.active = true;
        this.root.activeMenuItem.active = false;
        this.root.archiveMenuItem.$el.attr('aria-selected', 'true');
        this.root.activeMenuItem.$el.attr('aria-selected', 'false');
        this.root.archiveMenuItem.$el.attr('aria-pressed', 'true');
        this.root.activeMenuItem.$el.attr('aria-pressed', 'false');
        this.typeModel.set('archive', true);
        this.root.spfHelper.filter.unset('expirationDate');
      } else {
        this.root.activeMenuItem.active = true;
        this.root.activeMenuItem.$el.attr('aria-selected', 'true');
        this.root.archiveMenuItem.$el.attr('aria-selected', 'false');
        this.root.activeMenuItem.$el.attr('aria-pressed', 'true');
        this.root.archiveMenuItem.$el.attr('aria-pressed', 'false');
        this.root.archiveMenuItem.active = false;
        this.typeModel.unset('archive');
        this.root.spfHelper.filter.unset('finalizedDate');
      }
      this.root.setupColumns(this.getStudyColumns());
      this.root.setupVisualSearch(this.getStudyFields(), this.state);
    },
    onStart: function onStart() {
      var app = this.app,
        region = this.region,
        state = this.state;
      app.execute('achievement:unlock', 'Study Checker');
      var root = new PageList({
          sectionTitle: p('StudiesPage.Title'),
          useTableHeader: true,
          tableHeaderText: state.get('type') === 'active' ? p('StudiesPage.TableHeader.Active') : p('StudiesPage.TableHeader.Archive')
        }),
        studies = Study.all(true),
        typeModel = new Backbone.Model(),
        createStudy = new UIKit.Button({
          visible: !!app.authorities.findWhere({
            authority: 'ROLE_IRB_USER'
          }),
          text: p('StudiesPage.CreateStudyButton'),
          link: RouteHelper.resolve('study:create'),
          icon: 'plus',
          color: 'primary',
          attributes: {
            role: 'button',
            'aria-label': p('StudiesPage.CreateStudyButton.ARIALabel')
          }
        }),
        table = root.table;
      this.root = root;
      this.studies = studies;
      this.typeModel = typeModel;
      studies.addAdapter(new ParamAdapter(typeModel));
      root.$el.css(config.contentCss);
      root.headerRightContainer.add(createStudy);
      root.headerLeftContainer.add(new UIKit.Container({
        attributes: {
          style: 'margin-top: 1em;'
        }
      }).add(new UIKit.Menu({
        template: Templates.IRB['studylist.tabs.menu'],
        className: UIKit.Menu.prototype.className + ' study-tabs-menu',
        secondary: true,
        pointing: true,
        compact: true,
        color: 'blue'
      }).add(this.root.activeMenuItem = new ToolbarMenuItem({
        text: p('StudiesPage.FilterBy.Active'),
        link: true,
        role: "tab",
        attributes: _.extend(ToolbarMenuItem.prototype.attributes, {
          'aria-label': p('StudiesPage.FilterBy.Active.ARIALabel')
        })
      }).on('press', function () {
        state.set('type', 'active');
        root.tableHeaderText = p('StudiesPage.TableHeader.Active');
      })).add(this.root.archiveMenuItem = new ToolbarMenuItem({
        text: p('StudiesPage.FilterBy.Archive'),
        link: true,
        role: "tab",
        attributes: _.extend(ToolbarMenuItem.prototype.attributes, {
          'aria-label': p('StudiesPage.FilterBy.Archive.ARIALabel')
        })
      }).on('press', function () {
        state.set('type', 'archive');
        root.tableHeaderText = p('StudiesPage.TableHeader.Archive');
      }))));
      this.listenTo(this.root.headerLeftContainer, 'after:render:all', function () {
        this.root.headerLeftContainer.$el.find('.study-tabs-menu').attr({
          role: 'tablist',
          tabindex: '0',
          'aria-label': 'filter studies list'
        });
      });
      root.setupCollection(studies, {
        autoFetch: true,
        filter: FILTER_OPTIONS
      }).setupSortDefaults(DEFAULT_SORT).setupLoading().setupEmptyView(EmptyTableView.Row, {
        text: p('StudiesPage.NoStudies'),
        headerTag: 'h4'
      }).setupRowLink('study:detail', {
        studyId: 'id'
      }).setupPaginate().setupPageSizes().setupTableSort();
      table.compact = false;
      table.padded = true;
      table.tabletStackable = true;
      function applyAuthority() {
        if (app.role.get('description') === User.IRB_ADMIN) {
          root.spfHelper.filter.unset('role');
        } else {
          root.spfHelper.filter.set('role', app.role.get('description'));
        }
      }
      ;
      root.listenTo(app.role, 'change:description', applyAuthority);
      state.addPageDependencies([studies]).on('page:loaded', function () {
        region.show(root);
      });
      this.listenTo(state, 'change:type', this.onChangeStateType);
      this.listenTo(state, 'change:type', _.debounce(function () {
        studies.fetch();
      }));
      this.onChangeStateType();
      if (app.role.has('description')) {
        applyAuthority();
        studies.fetch();
      } else {
        app.role.once('change:description', function () {
          studies.fetch();
        });
      }
    }
  });
  module.exports = StudyListController;
});

